module.exports = __webpack_public_path__ + "img/init.06a0bf0a.png";